// The Scheduled panel's view of the agenda (unattended.md section 11), from GET /api/agenda. Pure,
// so it is tested without a browser.

export interface AgendaEntry {
  id: string;
  what: string;
  state: "active" | "started" | "paused" | "done";
  setBy: "agent" | "quanty_after_paid_runs";
  next: string;
  everyMinutes?: number;
  until?: string;
  pausedReason?: "failures" | "person" | "attention";
  blocked?: "reconnect_required" | "credits" | "daily_limit";
  failures?: number;
}

export interface Agenda {
  paused: boolean;
  entries: AgendaEntry[];
}

const PAUSED: Record<string, string> = {
  person: "paused",
  failures: "paused after 3 failed check-ins",
  attention: "paused after 100 check-ins; resume to keep following the runs",
};

const BLOCKED: Record<string, string> = {
  reconnect_required: "waiting for you to reconnect AlphaLab",
  credits: "waiting for AlphaLab Credits",
  // Entries blocked before the daily caps went; their next record clears it.
  daily_limit: "waiting for tomorrow's messages",
};

function time(iso: string): string {
  const at = new Date(iso);
  return Number.isNaN(at.getTime()) ? iso : at.toLocaleString([], { weekday: "short", hour: "2-digit", minute: "2-digit" });
}

/** One line under an entry's request: when it runs, how often, and why it waits. */
export function describeEntry(e: AgendaEntry): string {
  const parts: string[] = [];
  if (e.state === "started") parts.push("running now");
  else if (e.state === "paused") parts.push(PAUSED[e.pausedReason ?? "person"] ?? "paused");
  else parts.push(`next ${time(e.next)}`);
  if (e.everyMinutes !== undefined) parts.push(`every ${e.everyMinutes} minutes${e.until ? ` until ${time(e.until)}` : ""}`);
  if (e.blocked) parts.push(BLOCKED[e.blocked] ?? e.blocked);
  if (e.setBy === "quanty_after_paid_runs") parts.push("follows your paid runs");
  return parts.join(" · ");
}

/** The question asked before the runs follow-up stops following runs it still tracks. */
export function abandonQuestion(handles: string[], more: boolean): string {
  return `Quanty One is still following these runs:\n${handles.join("\n")}${more ? "\nand more" : ""}\n\nStop following them?`;
}
